export default __webpack_public_path__ + "static/media/card-gestiones.abcd22f3.png";